import { useCallback } from 'react';

import { Stack } from '@mui/material';

import { SideModal } from '@/components';

import {
  CustodyLogs,
  ToOwnerForm,
  CheckInForm,
  CheckoutForm,
  ReleaseForm,
  ToPersonForm,
  ToOtherAgencyForm,
  PropertyPrintLabel,
  PropertyBulkPrintLabel,
  PropertyPrintCustodyLogs,
  PropertyBulkPrintCustodyLogs,
} from './sidemodal-content';
import { CustodyActions } from '../data';
import { useKasePropertyContext } from '../PropertyContext';

export const PropertyCustodyModal = () => {
  const {
    custodyModalValues: { custodyAction, open },
    setCustodyModalValues,
  } = useKasePropertyContext();

  const renderCustodyModalContent = useCallback(() => {
    switch (custodyAction) {
      case CustodyActions.CUSTODY_LOGS:
        return <CustodyLogs />;
      case CustodyActions.TO_OWNER:
        return <ToOwnerForm />;
      case CustodyActions.CHECK_IN:
      case CustodyActions.MOVE_LOCATION:
        return <CheckInForm custodyAction={custodyAction} />;
      case CustodyActions.TO_COURT:
      case CustodyActions.TO_LAB:
        return <CheckoutForm custodyAction={custodyAction} />;
      case CustodyActions.TO_PERSON:
        return <ToPersonForm />;
      case CustodyActions.DISPOSE:
      case CustodyActions.DESTROY:
      case CustodyActions.AUCTION:
        return <ReleaseForm custodyAction={custodyAction} />;
      case CustodyActions.TO_OTHER_AGENCY:
        return <ToOtherAgencyForm />;
      case CustodyActions.PRINT_LABEL:
        return <PropertyPrintLabel />;
      case CustodyActions.PRINT_LABELS:
        return <PropertyBulkPrintLabel />;
      case CustodyActions.PRINT_CUSTODY_LOGS:
        return <PropertyPrintCustodyLogs />;
      case CustodyActions.PRINT_BULK_CUSTODY_LOGS:
        return <PropertyBulkPrintCustodyLogs />;
      default:
        return null;
    }
  }, [custodyAction]);

  const handleClose = () => {
    setCustodyModalValues({});
  };

  return (
    <SideModal open={!!open} onClose={handleClose}>
      <Stack
        sx={{
          width: '100%',
          padding: '0 16px 16px',
        }}
      >
        {renderCustodyModalContent()}
      </Stack>
    </SideModal>
  );
};
